import React from "react";
import ReactDOM from "react-dom";
import {ShoppingCart} from "./ShoppingCart";

const cartNode = document.querySelector("#cart");

if (cartNode) {
    ReactDOM.hydrate(<ShoppingCart />, cartNode);
}
